import { Expose, Transform, Type } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';

export class AnnualVacationQuotaModel {
  public id? = null;

  @Expose({ name: 'amount' })
  @Type(() => Number)
  public amount = -1;

  @Expose({ name: 'user_id' })
  public userId? = null;

  @Expose({ name: 'starting_from' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public startingFrom: Date = null;
}
